import { globalErrorHandler } from "@/helpers/globalResponseHandler";
import { api } from "@/lib/fetch/apiSetup";
import { ApiResponse } from "@/types/api/API";
import { Package } from "@/types/packages/data-only/DataOnlyCountryPackages";
import { Locale } from "next-intl";

interface PackageDetailResponse {
  data: Package;
}

export async function getPackageDetail({
  packageId,
  locale,
}: {
  packageId: string | number;
  locale: Locale;
}): Promise<ApiResponse<Package>> {
  try {
    const response = await api<PackageDetailResponse>(
      `/packages/detail/${packageId}?platform=web`,
      null,
      locale,
      { method: "GET" },
    );

    return { status: true, data: response.data };
  } catch (error) {
    return { status: false, message: globalErrorHandler(error) };
  }
}
